export const config = {
  clientLoginPath: process.env.LP_CLIENT_LOGIN_PATH || '/sign-in/contractor',
}
